import { useState } from "react";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
// import { Link } from "react-router-dom";
// import AlertBox from "../../components/AlertBox";
import Pagination from "../../components/Pagination";
import { useAddonList } from "../../utils/addons/AddonUtils";
import moment from "moment";

function AddonStatusBadge({ status }) {
  switch (status?.toLowerCase()) {
    case "active":
      return <span className="badge badge-success">Aktif</span>;
    case "suspended":
      return <span className="badge badge-danger">Ditangguhkan</span>;
    case "pending":
      return <span className="badge badge-warning">Tertunda</span>;
    default:
      return <span className="badge badge-secondary">{status || "-"}</span>;
  }
}

export default function ReportAddonPage() {
  const [formFilter, setFormFilter] = useState({ q: "" });
  const [filter, setFilter] = useState({ q: "", page: 1, page_size: 10 });
  const { customers, meta, loading } = useAddonList({ filter });

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      q: "",
    });
    setFilter({
      q: "",
      page: 1,
      page_size: 10,
    });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="customer">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Addon</h1>
          </div>
          {/* <div className="col-auto">
            <button className="btn btn-primary">
              <i className="fa fa-download"></i> Unduh Report
            </button>
          </div> */}
        </div>
        <div className="row">
          <div className="col-12">
            <Box title={`List Akun Add-ons (Total: ${meta.count} pengguna)`} loading={loading}>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <label>Pencarian</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formFilter.q}
                      placeholder="No. Pelanggan/Nama"
                      onChange={(event) => setFormFilter({ ...formFilter, q: event.target.value })}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>No. Pelanggan</th>
                      <th>Nama</th>
                      <th>User Akun</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.map((customer, index) => (
                      <tr key={index}>
                        <td>{customer.customer_number}</td>
                        <td>{customer.name}</td>
                        <td>
                          <table className="table table-bordered table-sm table-striped">
                            <thead>
                              <tr>
                                <th>Akun</th>
                                <th>Addon</th>
                                <th>Paket</th>
                                <th>Status</th>
                                <th>Tgl. Pendaftaran</th>
                              </tr>
                            </thead>
                            <tbody>
                              {customer.customer_addons?.map((addon, index) => (
                                <tr key={index}>
                                  <td style={{ width: "400px" }}>{addon.account_email}</td>
                                  <td>{addon.addon_name}</td>
                                  <td>{addon.product_name || "-"}</td>
                                  <td>
                                    <AddonStatusBadge status={addon.product_status} />
                                  </td>
                                  <td className="text-nowrap">
                                    {addon.created_at
                                      ? moment.unix(addon.created_at).format("DD MMM YYYY - HH:mm")
                                      : "-"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {meta.count > meta.page_size && (
                <Pagination
                  totalpage={Math.ceil(meta.count / meta.page_size)}
                  selectedpage={meta.page}
                  clickpage={(page) => gotoPage(page)}
                  next={() => gotoPage(meta.page + 1)}
                  prev={() => gotoPage(meta.page - 1)}
                />
              )}
            </Box>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
